import { Container } from '@cgs/wge';
import { ISlotGame } from '../../reels_engine/i_slot_game';
import { LineModel } from '../../reels_engine/line_model';
import { T_ISlotGame, RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { ILinesModelProvider } from './interfaces/i_lines_model_provider';
import { ResourcesComponent } from './resources_component';

export class LineModelComponent implements ILinesModelProvider {
  lineModel: LineModel;
  constructor(container: Container) {
    console.log('load ' + this.constructor.name);
    const game: ISlotGame = container.resolve<ISlotGame>(T_ISlotGame);
    const res: ResourcesComponent =
      container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const lw = res.slot.findById('line_width')!;
    if (game.linesConfig) {
      this.lineModel = new LineModel(game.linesConfig, game.symbolsBounds, lw.size.x);
    }
  }
}
